<template>
  <v-dialog
    persistent
    v-model='get_dialogMain.dialog'
    :width='get_dialogMain.withWindows'
    justify-center
  >
    <v-card width='auto' tile>
      <v-toolbar dense dark color='primary darken-2'>
        <v-toolbar-title class="text-uppercase"><h3>{{ get_dialogMain.title }}</h3></v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click='HIDDE_DIALOG_MAIN'><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class='pa-2'>
        <MainProcessForm v-if="get_dialogMain.type === 'process'" :form='form' :model='nomina' :on-success='saveProcess' :on-cancel='cancel'/>
        <MainGeneralForm v-if="get_dialogMain.type === 'general'" :form='form' :model='model' :on-success='saveGral' :on-cancel='cancel'/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainProcessForm from '@/components/forms/main/MainProcessForm'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
export default {
  props: ['model', 'params'],
  data: () => ({
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    nomina: {}
  }),
  components: {
    MainProcessForm,
    MainGeneralForm
  },
  mounted () {
    if (this.get_dialogMain.type === 'process') {
      if (this.model.action) {
        this.form = this.model.body
      } else {
        this.nomina = Object.assign({}, this.model)
        this.getFormServices('GET/rh/empleado/options/{procss}[/{id}]')
      }
    } else if (this.get_dialogMain.type === 'general') {
      this.form = this.params.form
    }
  },
  methods: {
    ...mapActions(['GetFormOptionServicesAction', 'postServiceActionMultipart', 'postExecuteAction']),
    createFormData (object) {
      const formData = new FormData()
      for (const property in object) {
        // console.log(`${property}: ${object[property]}`)
        formData.append(`${property}`, object[property])
      }
      return formData
    },
    saveProcess (model) {
      /*
      if (this.get_dialogMain.type !== 'create') {
        model.cve_empleado = this.model.item.cve_empleado
      }
      */
      if (this.params.update) {
        model.action = 'toEditEmpleado'
      }
      const router = this.get_urls['POST/rh/empleado/execute']
      this.postExecuteAction({ url: router, data: model })
    },
    saveGral (model) {
      if (this.params.formData) {
        const formData = this.createFormData(model)
        // console.log(formData)
        this.postServiceActionMultipart({ url: this.params.url, data: formData })
        return
      }
      this.postExecuteAction({ url: this.params.url, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    // * ========== * ========== * ========== * ========== * ========== *
    getFormServices (url) {
      const router = this.get_urls[url]
      this.GetFormOptionServicesAction({ url: router, data: {}, params: '/2' })
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_STRING', 'SET_RELOAD_DATA', 'CLEAR_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_options', 'get_model', 'get_object'])
  },
  watch: {
    get_options (val) {
      if (val) {
        this.form = val
      }
    },
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: (this.params.message) ? this.params.message : 'Registro agregado correctamente'
      })
      if (this.params.reload) {
        this.SET_RELOAD_DATA(val)
        this.cancel()
        return
      }
      this.SET_DATA_STRING(val)
      this.cancel()
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: (this.params.message) ? this.params.message : 'Registro agregado correctamente'
      })
      if (this.params.reload) {
        this.SET_RELOAD_DATA(val)
        this.cancel()
        return
      }
      this.cancel()
    }
  }
}
</script>

<style></style>
